import api from '../callApi';
import humanparser from 'humanparser';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const sendEmailErrorMessage = "Couldn't send email, try again later";

const getErrorMessage = errorList =>
    errorList && errorList.length ? errorList[0] : sendEmailErrorMessage;

const completeEmail = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    actionType,
    emailTopic,
    emailMessage,
    useLocalRepresentative,
    localRepDataRepresentatives
) => {
    const name = humanparser.parseName(values.fullName);
    const addressParsedNumber = parseAddressNumber(values.Street);
    const addressParsedStreet = parseAddressStreet(values.Street);
    const localRepDataRepresentative =
        localRepData.representative !== undefined && useLocalRepresentative;
    let representatives = [];
    let address = {
        source: 1
    };

    if (localRepDataRepresentative) {
        address = {
            source: localRepData.isUserInput || Object.keys(values).length > 5 ? 0 : 1, // source: 0 = user input
            country: 'US',
            state: values.State || localRepData.address.state,
            county: values.County,
            city: values.City || localRepData.address.city,
            zipCode: values.Zip || localRepData.address.zipCode,
            street: addressParsedStreet || localRepData.address.street,
            streetNo: addressParsedNumber || localRepData.address.streetNo
        };

        if (actionType === 1) {
            representatives = [
                {
                    level: localRepData.representative[0].level,
                    name: localRepData.representative[0].fullName,
                    state: localRepData.state,
                    districtNo: localRepData.district
                }
            ];
        } else if (actionType === 2 || actionType === 3) {
            representatives = localRepDataRepresentatives.map(rep => ({
                level: rep.level,
                bioguideId: rep.bioguideId,
                name: rep.fullName,
                state: localRepData.state,
                districtNo: localRepData.district
            }));
        }
    }

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,

        from: values.email,
        firstName: name.middleName
            ? name.firstName + ' ' + name.middleName
            : name.firstName,
        lastName: name.lastName || name.suffix,
        prefix: values.prefix,
        text: emailMessage || values.message,
        notifyResult: values.getUpdates,

        representatives: representatives,
        topic: emailTopic,
        phoneNumber: values.Phone,

        address: address
    };

    return api.post('Widget/SendEmailAsync', request).then(response => {
        let isValid = false;
        for (let i = 0; i < response.emailStatusList.length; i++) {
            if (response.emailStatusList[i].status < 2) {
                isValid = true;
            }
        }
        return isValid ? response : Promise.reject(getErrorMessage(response.errorList));
    });
};

export default completeEmail;



// WEBPACK FOOTER //
// ./src/utils/email/emailApi.js